import React, { useState, useLayoutEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_LATEST_ENTRIES, GET_FEED_BY_ID } from "../../queries/queries";
import Error from "../error";
import Loading from "../loading";
import Entry from "./Entry";
import NewsModal from "./NewsModal";
import { useLocation } from "react-router-dom";
import useMakeScrollable from "../../custom_hooks/make-scrollable";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

function EntriesList({ setShowHeart, setEntryId, setShowEntryList, showEntryList, ...props }) {
  const [showIframeUrl, setShowIframeUrl] = useState("");
  const id = props.match.params.id;

  const { loading, error, data } = useQuery(GET_LATEST_ENTRIES, {
    variables: { feedId: parseInt(id) },
    fetchPolicy: "no-cache",
  });

  useMakeScrollable()
  const availableFeed = useQuery(GET_FEED_BY_ID, {
    variables: { id: parseInt(id) },
    fetchPolicy: "no-cache",
  });

  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top:0, left:0, behavior: "instant" });
}, [location.pathname]);

  const history = useHistory();
  const handleBack = () => {
    history.goBack() 
  };

  if (loading || availableFeed.loading) return <Loading />;
  if (error || availableFeed.error) return <Error />;

  const url = availableFeed.data.getFeedById.url;
  const baseUrl = availableFeed.data.getFeedById.baseUrl;

  let content = <NewsModal url={showIframeUrl} />;
  if (showEntryList) {
    content = data.getLatestEntries.map((entry, index) => {
      return (
        <Entry
          index={index}
          key={index}
          id={entry.id}
          title={entry.titel}
          excerpt={entry.excerpt}
          slug={entry.url}
          url={url}
          setShowIframeUrl={setShowIframeUrl}
          baseUrl={baseUrl}
          setShowEntryList={setShowEntryList}
          logo={entry.logoUrl}
          setShowHeart={setShowHeart}
          setEntryId={setEntryId}
          renderMode={entry.renderMode}
          content={entry.content}
          publishedAt={entry.publishedAt}
        />
      );
    });
  }
  const feedClassName = classNames({
    "feed-iframe": !showEntryList,  // Applies "feed-iframe" if there is an iframe
    "feed-list": showEntryList,    // Applies "feed-list" if it's showing the entry list
  });

  return (
    <div className="scrollable">
      <div className={feedClassName}>
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
          style={{ padding: 12 }}
        />
        {content}
      </div>
    </div>
  );
}

export default EntriesList;
